export type Compania = any

export interface CompaniasState {
    loading: boolean
    companias: Compania[]
}

const initialState: CompaniasState = {
    loading: false,
    companias: []
}

export const companiasReducer = (state: CompaniasState = initialState, action: { type: string; payload?: any }): CompaniasState => {
    switch (action.type) {
        case "COMPANIA_GETALL_SUCCESS":
            return {
                ...state,
                companias: action.payload.companias as Compania[]
            }
        case "COMPANIAS_IMPORT_SUCCESS":
            return {
                ...state,
                companias: action.payload.companias as Compania[]
            }
        case "COMPANIAS_LOADING":
            return {
                ...state,
                loading: true,
            }

        case "COMPANIAS_NOT_LOADING":
            return {
                ...state,
                loading: false,
            }
        default:
            return state
    }
}
